import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-role-extended-rights-description-card',
    template: `
        <mat-card>
            <mat-card-title>{{ 'role.relations' | fiAppText }}</mat-card-title>

            <div class="card-section">
                <p class="bold no-margin">{{ 'extended_rights.may_share_content_with' | fiAppText }}</p>
                <p class="no-margin" [innerHTML]="'extended_rights.may_share_content_with_description' | fiAppText"></p>
            </div>

            <div class="card-section">
                <p class="bold no-margin">{{ 'extended_rights.may_manage_staff_in' | fiAppText }}</p>
                <p class="no-margin">{{ 'extended_rights.may_manage_staff_in_description' | fiAppText }}</p>
            </div>

            <mat-card-title>{{ 'common.extended_rights' | fiAppText }}</mat-card-title>

            <div class="card-section">
                <p class="bold no-margin">{{ 'common.content' | fiAppText }}</p>
                <p class="no-margin" [innerHTML]="'extended_rights.share_content_description' | fiAppText"></p>
            </div>

            <div class="card-section">
                <p class="bold no-margin">{{ 'extended_rights.manage_users_and_units' | fiAppText }}</p>
                <p class="no-margin" [innerHTML]="'extended_rights.manage_users_and_units_description' | fiAppText"></p>
            </div>
        </mat-card>
    `,
    styleUrls: ['./role-extended-rights-description-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-role-extended-rights-description-card' },
    standalone: false,
})
export class RoleExtendedRightsDescriptionCardComponent {}
